module.exports = __webpack_public_path__ + "static/media/bbc.33486334.svg";